import { z } from 'zod'
import {
  eventDataSchema,
  filterDataSchema,
  resultsDataSchema,
  zodResultsDataInputTypeEnum,
} from '../common.schema'

export const ViewGalleryResultsSchema = z.object({
  event: z.literal('view_gallery_results'),

  event_data: eventDataSchema,
  results_data: resultsDataSchema.extend({
    input_type: zodResultsDataInputTypeEnum.or(
      z.enum([
        'nba',
        'quick filters',
        'filters menu',
        'filter',
        'gallery',
        'collection',
        'entry point banner',
        'reminder prompt',
        'rude toggle within grid',
        'guided nbas',
      ]),
    ),
  }),
  filter_data: filterDataSchema,
})

export type ViewGalleryResultsEvent = z.infer<typeof ViewGalleryResultsSchema>
